import React from 'react';
import { Helmet } from 'react-helmet';

import schemaData from './schema.json';

export interface BlogSchemaProps {
  id: string;
  headline: string;
  description: string;
  images: string[];
}

const BlogSchema = ({ id, headline, description, images }: BlogSchemaProps): React.JSX.Element => {
  const modifiedSchemaData = schemaData;
  modifiedSchemaData.mainEntityOfPage['@id'] = id;
  modifiedSchemaData['headline'] = headline;
  modifiedSchemaData['description'] = description;
  modifiedSchemaData['image'] = images;

  return (
    <Helmet>
      <script type="application/ld+json">{`${JSON.stringify(schemaData)}`}</script>
    </Helmet>
  );
};

export default BlogSchema;
